import { SidebarMainPanelBlock } from 'im.v2.const';

export const baseBlocks = [
	SidebarMainPanelBlock.chat,
	SidebarMainPanelBlock.tariffLimit,
	SidebarMainPanelBlock.info,
	SidebarMainPanelBlock.fileList,
	SidebarMainPanelBlock.fileUnsortedList,
	SidebarMainPanelBlock.taskList,
	SidebarMainPanelBlock.meetingList,
	SidebarMainPanelBlock.marketAppList,
];
